import { toVersion } from '@studio/models/agent';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Badge } from './badge.jsx';
import type { HardwareProps } from './types.js';
import { Icon } from '#~/agent/components/icon/index.js';

/** `<Hardware>` component. */
export const Hardware = ({ agent, className, linked, ...props }: HardwareProps): ReactElement => (
  <div className={twMerge('flex flex-col items-center gap-8', className)} {...props}>
    {/* Limit photos only in constrained windows so desktop artwork keeps its original size. */}
    <div
      className={twMerge(
        'flex min-h-[120px] items-center [&_img]:max-h-[120px] [&_img]:object-contain [@media(min-width:480px)_and_(min-height:720px)]:min-h-[150px] [@media(min-width:480px)_and_(min-height:720px)]:[&_img]:max-h-none',
        className
      )}
      role='img'
    >
      <div className='relative'>
        <Icon agent={agent} />
        {!!agent.embedded && <Badge className='absolute -right-20 -top-2' />}
      </div>
    </div>

    <div className='mt-8 text-base font-bold'>{agent.name}</div>
    <div className='font-demibold text-primary'>Software version {toVersion(agent.version)}</div>
  </div>
);
